import React, { useState } from 'react';

const SearchBar: React.FC<{ onSearch: (tag: string) => void }> = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSearch(searchTerm);
    };

    return (
        <form onSubmit={handleSearch} style={{ marginBottom: '24px', display: 'flex', gap: '12px' }}>
            <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by tag..."
                style={{
                    padding: '12px 16px',
                    width: '300px',
                    background: '#1e1e1e',
                    border: '1px solid #333',
                    borderRadius: '8px',
                    color: '#e0e0e0',
                    fontSize: '14px',
                    outline: 'none',
                }}
            />
            <button
                type="submit"
                style={{
                    padding: '12px 24px',
                    background: '#333',
                    color: '#e0e0e0',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: '14px',
                }}
            >
                Search
            </button>
        </form>
    );
};

export default SearchBar;